// import apiFetch from '../apiFetch'
export default function (token) {
  return {} // apiFetch({endPoint: 'notificationDocument', method: 'GET', body: null, token: token})
}
